import React from 'react'
import _ from 'lodash'
import User from './User'

const pull_title_regex = /#(?<issue_number>\d+)\/(?<is_wip>\[WIP\])?\s*(?<title>.+)\s*/

// FIXME
const issue_url_base = 'https://github.com/vacuumlabs/bee/issues'

class PullRequest extends React.PureComponent {
  parse_title(title) {
    const result = title.match(pull_title_regex)
    if (result === null) {
      return {
        title,
        is_wip: null,
        issue_number: null,
      }
    }
    return {
      ...result.groups,
      is_wip: result.groups.is_wip === '[WIP]'
    }
  }

  render_assignee() {
    const assignee = _.get(this.props.pull, ['assignee'])
    if (!assignee) {
      return <span className="error user">No assignee</span>
    }
    return <User user={assignee} />
  }

  render() {
    const {title: raw_title, number: pr_number, html_url, requested_reviewers, assignee, head: {ref}, user} = this.props.pull
    const {title, issue_number, is_wip} = this.parse_title(raw_title)
    const issue_url = `${issue_url_base}/${issue_number}`

    return (
      <div className="pull" key={pr_number}>
        <div className="title">
          {issue_number && (<span className="issue-number-badge">
            <a href={issue_url} target="_blank" rel="noopener noreferrer">#{issue_number}</a>
          </span>)}
          {is_wip && <span className="wip-badge">WIP</span>}
          <a href={html_url} target="_blank" rel="noopener noreferrer">{title}</a>
          <div className="branch">{ref}</div>
        </div>

        <div className="assignee">Assignee: {this.render_assignee(assignee)}</div>
        {!assignee && <div className="author">Author: <User user={user}/></div>}

        {/* <div className='created-at'>Created: {pull.created_at}</div>
        <div className='updated_at'>Updated: {pull.updated_at}</div> */}
        <div className="reviewers">
          Reviewers:&nbsp;
          {_.isEmpty(requested_reviewers)
            ? <span className={!is_wip ? 'error' : ''}>No reviewers</span>
            : <ul>{requested_reviewers.map((reviewer) => <li key={reviewer.login}><User user={reviewer} /></li>)}</ul>}
        </div>
      </div>
    )
  }
}

export default PullRequest
